import { map, reject, values } from 'ramda'

import { History, Params } from 'app/dataTypes/reports/history'

import type { Request } from '../../index'
import { apiStringFromReportType } from '../data/_predefined/api-string-from-report-type'

type ApiParams = {
  limit?: number
  offset?: number
  history_type?: 'all'
  report_type?: string
  report_format?: 'xlsx' | 'zip'
}

export const convertParams = (params: Params): [ApiParams, null] => {
  const { limit, offset, historyType, reportType, reportFormat } = params

  return [
    reject((val) => val === undefined, {
      limit,
      offset,
      history_type: historyType,
      report_type: apiStringFromReportType(reportType),
      report_format: reportFormat,
    }),
    null,
  ]
}

export type ApiResult = Record<
  string,
  {
    id: number
    title: string
    downloads_count: number
    created_at: string // "2017-08-20T14:33:01+03:00",
    status: number // -1 - если ошибка, иначе процент готовности (0-100)
  }
>

export const convertResult = (data: ApiResult): History => {
  return map(
    ({ id, title, downloads_count: downloads, created_at: createdAt, status }) => ({
      id: String(id),
      title,
      downloads,
      createdAt,
      status,
    }),
    values(data),
  )
}

export const GET_HISTORY: Request<Params, History, void> = [
  'reports/history',
  'get',
  ['data', 'reports'],
]
